import firebase from 'firebase/compat/app';
import 'firebase/compat/analytics';
import 'firebase/compat/auth';
import 'firebase/compat/firestore';
import 'firebase/compat/functions';
import 'firebase/compat/storage';

import { Elements } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';
import ReactDOM from 'react-dom/client';
import 'material-design-icons/iconfont/material-icons.css';
import './index.css';
import Application from './src/Application';
import { createBrowserHistory, createMemoryHistory } from 'history';
import { RouterStore, syncHistoryWithStore } from 'mobx-react-router';
import AccountService from './src/service/AccountService';
import FileService from './src/service/FileService';
import { getPlatformType } from './src/Config';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import { Theme } from '@mui/material/styles';
import '@mui/styles';
import * as React from 'react';
import ChatMessaengerService from './src/service/ChatMessengerService';
import SendService from './src/service/sendService';

declare module '@mui/styles' {
  interface DefaultTheme extends Theme {}
}

const theme = createTheme({
  palette: {
    primary: {
      light: '#757ce8',
      main: '#3f50b5',
      dark: '#002884',
      contrastText: '#fff',
    },
    secondary: {
      light: '#ff7961',
      main: '#f44336',
      dark: '#ba000d',
      contrastText: '#000',
    },
  },
});

//test mode api key
// const stripePromise = loadStripe('pk_test_jiuunbkbAgm7KXfisJN3wlhv');

//live mode api key
const stripePromise = loadStripe('pk_live_G8qBlnNxh2SHb8ayqNfBlXKr');

export async function bootstrap() {
  var firebaseConfig = {
    apiKey: 'AIzaSyCv2s9hjK2hVRuHxgLrx5fqzmGlA245Pys',
    authDomain: 'ai-flowchart.firebaseapp.com',
    databaseURL: 'https://ai-flowchart.firebaseio.com',
    projectId: 'ai-flowchart',
    storageBucket: 'ai-flowchart.appspot.com',
    messagingSenderId: '175201962411',
    appId: '1:175201962411:web:d4addf8be33fa2061e2aee',
    measurementId: 'G-5Y9QNRBY73',
  };
  // Initialize Firebase
  firebase.initializeApp(firebaseConfig);
  firebase.firestore().settings({ experimentalForceLongPolling: true });
  firebase.analytics();

  const browserHistory =
    getPlatformType() == 'MOBILE'
      ? createMemoryHistory()
      : createBrowserHistory();

  const routingService = new RouterStore();
  const history = syncHistoryWithStore(browserHistory, routingService);

  const accountService = new AccountService(routingService);
  await accountService.initialize();

  const fileService = new FileService(accountService);
  await fileService.initialize();

  const chatMessengerService = new ChatMessaengerService(accountService);
  await chatMessengerService.initialize();

  const sendService = new SendService(accountService, chatMessengerService);
  await sendService.initialize();

  var content = ReactDOM.createRoot(document.querySelector('#app-content'));
  content.render(
    <Elements stripe={stripePromise}>
      <ThemeProvider theme={theme}>
        <Application
          routingService={routingService}
          fileService={fileService}
          accountService={accountService}
          history={history}
          chatMessengerService={chatMessengerService}
          sendService={sendService}
        />
      </ThemeProvider>
    </Elements>
  );
}
